(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb015"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb015"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $RIXNk = parcelRequire("RIXNk");

var $tMWS5 = parcelRequire("tMWS5");
const $2902c1a5f3a62e67$var$fetchTestData = async ()=>{
    const response = await fetch(`https://neuroflow.andypai.me/api/mnist?end=100&type=test`);
    const json = await response.json();
    return json;
};
const $2902c1a5f3a62e67$var$drawImage = (image)=>{
    const imageCanvas = document.createElement('canvas');
    const size = 14;
    const scale = size * 8;
    imageCanvas.width = scale;
    imageCanvas.height = scale;
    const ctx = imageCanvas.getContext('2d');
    const imageData = ctx.createImageData(size, size);
    image.forEach((pixel, idx)=>{
        const value = pixel * 255;
        imageData.data[idx * 4 + 0] = value;
        imageData.data[idx * 4 + 1] = value;
        imageData.data[idx * 4 + 2] = value;
        imageData.data[idx * 4 + 3] = 255;
    });
    // Create a temporary canvas to scale the image
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.putImageData(imageData, 0, 0);
    // Scale up the image and draw it on the image canvas
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(tempCanvas, 0, 0, size, size, 0, 0, scale, scale);
    return imageCanvas;
};
const $2902c1a5f3a62e67$var$main = async ()=>{
    const [test, autoencoder] = await Promise.all([
        $2902c1a5f3a62e67$var$fetchTestData(),
        $RIXNk.loadLayersModel('https://storage.googleapis.com/andypai-me/tfjs/mnist-autoencoder/model.json')
    ]);
    const table = (0, $tMWS5.default)(autoencoder);
    const architecture = document.getElementById('architecture');
    architecture.innerHTML = '' // Clear previous content
    ;
    architecture.appendChild(table);
    for (const { image: original } of test){
        const xsTensor = $RIXNk.tensor2d([
            original
        ]);
        const encoded = autoencoder.predict(xsTensor);
        const image = await encoded.array();
        const reconstructed = image[0].map((pixel)=>pixel > 0.5 ? 1 : 0);
        document.getElementById('original').innerHTML = '';
        document.getElementById('reconstructed').innerHTML = '';
        document.getElementById('original').appendChild($2902c1a5f3a62e67$var$drawImage(original));
        document.getElementById('reconstructed').appendChild($2902c1a5f3a62e67$var$drawImage(reconstructed));
        await new Promise((resolve)=>{
            setTimeout(resolve, 2000);
        });
    }
};
$2902c1a5f3a62e67$var$main();

})();
//# sourceMappingURL=mnist-autoencoder.5f12e8de.js.map
